import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import esriId from '@arcgis/core/identity/IdentityManager';
import OAuthInfo from '@arcgis/core/identity/OAuthInfo';
import App from './App';
import { appId, portalURL } from './constants/config';
import Portal from '@arcgis/core/portal/Portal';
import { appInsights } from './ApplicationInsightsService';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const oAuth = new OAuthInfo({
  appId: appId,
  portalUrl: portalURL,
  flowType: 'implicit',
});

esriId.registerOAuthInfos([oAuth]);

esriId
  .checkSignInStatus(portalURL + '/sharing/rest')
  .then(() => {
    const portal = new Portal({
      url: portalURL,
      authMode: 'no-prompt',
    });
    portal.load().then(() => {
      const user = portal.user?.username ?? '';
      appInsights.setAuthenticatedUserContext(btoa(user), btoa(user), true);
      appInsights.trackPageView();

      root.render(
        <React.StrictMode>
          <App user={user} />
        </React.StrictMode>
      );
    });
  })
  .catch(() => {
    esriId.getCredential(portalURL).then((cred) => {
      console.log(cred);
    });
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
